export default "__VITE_ASSET__CdIaPRgI__"